import { api } from './api';

export interface OverdueInvoice {
  invoiceId: string;
  invoiceNumber: string;
  clientName: string;
  studentName: string;
  dueDate: string;
  daysOverdue: number; // Negative = days until due
  balanceDue: number;
  clientEmail?: string;
}

export interface OverdueInvoicesResponse {
  invoices: OverdueInvoice[];
}

export const dashboardApi = {
  getOverdueInvoices: async (): Promise<OverdueInvoicesResponse> => {
    return api.get<OverdueInvoicesResponse>('/dashboard/overdue');
  },
};
